import { render, staticRenderFns } from "./site-statistics.vue?vue&type=template&id=f8e3951c&scoped=true&"
import script from "./site-statistics.vue?vue&type=script&lang=js&"
export * from "./site-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3951c",
  null
  
)

export default component.exports